import React from 'react';
import classNames from 'classnames';
import { image } from '../../../../utils/data/baseUrl';
import { icons } from '../../../../constants/rewards';

const GameResultModalReward = React.forwardRef(function GameResultModalReward({ type, value, mod }, ref) {
  return (
    <div
      className={classNames('game-result-modal__reward', {
        [`game-result-modal__reward_${type}`]: type,
        [`game-result-modal__reward_${mod}`]: mod,
      })}
    >
      <div className='game-result-modal__reward-icon'>
        <img src={image(icons[type])} alt={type} />
      </div>
      {value && (
        <div className={'game-result-modal__reward-value'}>
          {['coin', 'xp'].includes(type) && '+'}
          {value}
        </div>
      )}
    </div>
  );
});

export default GameResultModalReward;
